<template>
  <div class="game-container">
    <div class="barrage-container" ref="barrageContainer"></div>
    <div class="lottery-result-layer" v-if="showResultLayer">
      <div class="result-content">
        <div class="result-img-wrapper">
          <img src="@/assets/choujiang/cj-kuang.webp" class="result-bg" alt="" />
          <div class="result-text">{{ resultText }}</div>
        </div>
        <div class="result-close-btn" @click="closeResultLayer">×</div>
      </div>
    </div>
    <div class="lottery-record-btn" @click="handleShowRecord">抽奖记录</div>
    <img src="@/assets/choujiang/cjbg.png" alt="" class="cjbg" />
    <div class="lottery-container">
      <img src="@/assets/choujiang/cjtitle.png" class="cjtitle" alt="" />
      <div class="cj-container">
        <p class="canyuren">已有{{ canyuRen }}人参与活动</p>
        <img src="@/assets/choujiang/cjkuang.png" class="cjkuang" alt="" />
        <div class="lottery-grid">
          <div
            v-for="index in visualOrder"
            :key="index"
            :class="[
              'grid-item',
              { active: current === index },
              { 'choujiang-container': index === 4 },
            ]"
          >
            <div class="item-container" v-if="index !== 4">
              <img :src="gridImgItems[index]" class="item-img" alt="" />
              <span class="item-text">{{ gridItems[index] }}</span>
            </div>
            <div class="choujiang-container" v-else>
              <button
                class="choujiang"
                @click="startDraw"
                :disabled="isRolling"
                v-if="statusNum !== 3"
              >
                <span>抽奖</span>
                <span>消耗{{ jifen_count }}积分</span>
              </button>
              <button class="choujiang choujiang-over" disabled="true" v-else>
                <span>抽奖</span>
                <span>消耗{{ jifen_count }}积分</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cj-info-container">
      <div class="guize-container">
        <img src="@/assets/choujiang/guize.png" alt="" class="info-title" />
        <div class="info-content guize-content-container">
          <div class="guize-content" v-html="content"></div>
        </div>
      </div>
      <div class="jilu-container" ref="jiluContainerRef">
        <img
          src="@/assets/choujiang/zhongjiang.png"
          alt=""
          class="info-title"
        />
        <div class="info-content empty-tip" v-if="allLogList.length === 0">
          暂无中奖记录
        </div>
        <div class="info-content info-log-container" v-else ref="scrollWrapRef">
          <div
            class="scroll-list"
            :style="{ transform: `translateY(${scrollY}px)` }"
          >
            <el-row
              class="info-item"
              v-for="(item, index) in allLogList.concat(allLogList)"
              :key="index"
              align="middle"
            >
              <el-col :span="6">
                <el-text truncated class="name-text">{{
                  item.realname
                }}</el-text>
              </el-col>
              <el-col :span="11">
                <el-text truncated type="danger">{{ item.jp_name }}</el-text>
              </el-col>
              <el-col :span="7" class="date-col">
                <el-text size="small">{{ item.add_time }}</el-text>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showRecordDialog"
      :width="350"
      style="border-radius: 10px"
    >
      <template #header>
        <img src="@/assets/choujiang/jilu.png" alt="" class="info-title2" />
      </template>
      <div class="record-list">
        <div
          class="info-content"
          style="text-align: center"
          v-if="logList.length === 0"
        >
          暂无抽奖记录
        </div>
        <div
          class="info-content info-log-container"
          v-else
          ref="scrollContainerRef"
        >
          <div
            class="record-item"
            v-for="(item, index) in logList"
            :key="index"
          >
            <span class="prize">{{ item.jp_name }}</span>
            <span class="time">{{ item.add_time }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  ref,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  onDeactivated,
  nextTick,
  watch,
} from "vue";
import { getchoujianginfo, choujiang, getlog, getlogall } from "@/api/game.js";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";

const router = useRouter();
const instance = getCurrentInstance();
const message = instance.appContext.config.globalProperties.$message;

const storage = window.localStorage;
const uid = storage.getItem("uid");
const usertoken = storage.getItem("usertoken");

let autoPlayTimer = null;
const autoPlaySpeed = 200;
const startAutoPlay = () => {
  // 只有活动正常、未抽奖时才启动轮播
  if (statusNum.value === 3 || isRolling.value || autoPlayTimer) return;

  autoPlayTimer = setInterval(() => {
    // 找到当前索引，切换到下一个
    const currentIndex = drawOrder.findIndex((item) => item === current.value);
    const nextIndex = (currentIndex + 1) % drawOrder.length;
    current.value = drawOrder[nextIndex];
  }, autoPlaySpeed);
};

const stopAutoPlay = () => {
  if (autoPlayTimer) {
    clearInterval(autoPlayTimer);
    autoPlayTimer = null;
  }
};

const gridItems = ref(Array(9).fill(""));
const gridImgItems = ref(Array(9).fill(""));
const current = ref(-1);
const isRolling = ref(false);
const prizeIndex = ref(0);
const jifen_count = ref(0);
const statusNum = ref(0);
const content = ref("");
const activeCode = ref("");
const visualOrder = [0, 1, 2, 7, 4, 3, 6, 5, 8]; // 可视化格子顺序（视觉排列用）
const drawOrder = [0, 1, 2, 3, 8, 5, 6, 7]; // 抽奖轨迹（环绕中心顺时针）
const canyuRen = ref(0);

const showRecordDialog = ref(false);
const showResultLayer = ref(false);
const resultText = ref("");

const closeResultLayer = () => {
  showResultLayer.value = false;
  resultText.value = "";
};

const logList = ref([]);
const allLogList = ref([]);

const isPageActive = ref(true);
const barrageTimer = ref(null); // 全局弹幕定时器
const animationFrames = ref([]); // 存储所有动画帧ID
const barrageContainer = ref(null);
const activeBarrageMap = ref(new Map());
const activeBarrages = ref([]);
const activeBarragePositions = ref([]);

const jiluContainerRef = ref(null); // 外层容器
const scrollWrapRef = ref(null); // 滚动包裹层
const scrollY = ref(0); // 滚动偏移量（向上滚动为负数）
const scrollTimer = ref(null); // 滚动定时器
const itemHeight = ref(0); // 单条记录高度
const scrollSpeed = 1; // 滚动速度（px/帧，建议1~2）
const scrollInterval = 40; // 滚动间隔（ms，建议20~40）

onMounted(async () => {
  current.value = drawOrder[0];
  startAutoPlay();
  try {
    const res = await getchoujianginfo();

    const { jiangping } = res;
    const { code, summary, jifen, status, count } = res.Active;

    activeCode.value = code;
    content.value = summary;
    jifen_count.value = jifen;
    statusNum.value = status;
    canyuRen.value = count;

    if (statusNum.value === 3) {
      ElMessage("活动暂未开始");
    }

    const temp = Array(9).fill("");
    const img = Array(9).fill("");
    drawOrder.forEach((pos, i) => {
      temp[pos] = jiangping[i].name || "";
      img[pos] = jiangping[i].icon;
    });
    gridItems.value = temp;
    gridImgItems.value = img;
  } catch (e) {
    console.error("加载抽奖配置失败：", e);
  }

  try {
    const alllog_res = await getlogall({
      uid: uid,
      usertoken: usertoken,
      code: activeCode.value,
    });
    allLogList.value = alllog_res.data;
    await nextTick(() => {
      initBarrage();
    });
    // 主动触发滚动（即使watch有immediate，双重保障）
    if (allLogList.value.length > 0) {
      await initScroll();
    }
  } catch (e) {
    console.error("加载所有中奖记录配置失败：", e);
  }
});

onDeactivated(() => {
  isPageActive.value = false;
  if (barrageTimer.value) clearInterval(barrageTimer.value);
  forceCleanupAllBarrages(); // 页面隐藏时强制清理所有弹幕
});

onUnmounted(() => {
  stopAutoPlay();
  // 清理定时器
  if (barrageTimer.value) clearInterval(barrageTimer.value);
  // 强制清理所有弹幕
  forceCleanupAllBarrages();
  // 清空动画帧记录（冗余保险）
  animationFrames.value.forEach((id) => cancelAnimationFrame(id));
  animationFrames.value = [];
  stopScroll();
});

const handleShowRecord = async () => {
  // 1. 先请求最新数据
  await fetchMyLotteryLog();
  // 2. 再打开弹窗
  showRecordDialog.value = true;
};

const initBarrage = () => {
  // 前置校验：容器不存在/无中奖记录/页面不活跃，直接返回
  if (
    !barrageContainer.value ||
    allLogList.value.length === 0 ||
    !isPageActive.value
  )
    return;

  // 降低定时器频率：5~8秒生成一条（原3~5秒，减少创建频率）
  barrageTimer.value = setInterval(() => {
    if (isPageActive.value) createRandomBarrage();
  }, 5000 + Math.random() * 3000);

  // 初始创建1条（原2条，减少初始DOM压力）
  setTimeout(() => {
    if (isPageActive.value) createRandomBarrage();
  }, 1000);
};

const barragePositionMap = ref(new Map()); // key: 弹幕DOM, value: 对应的baseTop

// 优化 createRandomBarrage 中的位置计算逻辑
const createRandomBarrage = () => {
  if (
    !barrageContainer.value ||
    allLogList.value.length === 0 ||
    !isPageActive.value
  )
    return;
  if (activeBarrages.value.length >= 3) return;

  // 随机选记录
  let randomItem;
  let tryCount = 0;
  do {
    randomItem =
      allLogList.value[Math.floor(Math.random() * allLogList.value.length)];
    tryCount++;
  } while (
    activeBarrages.value.some(
      (barrage) =>
        barrage.item.realname === randomItem.realname &&
        barrage.item.jp_name === randomItem.jp_name
    ) &&
    activeBarrages.value.length < allLogList.value.length &&
    tryCount < 3
  );

  if (!randomItem) return;

  const container = barrageContainer.value;
  const containerWidth =
    container.clientWidth || document.documentElement.clientWidth;
  const containerHeight = container.clientHeight || 300;
  const barrageHeight = 40;

  // 计算 baseTop
  const minTop = 20;
  const maxTop = containerHeight - 60;
  let baseTop = minTop + Math.floor(Math.random() * (maxTop - minTop));

  // 碰撞检测：基于 Map 而非数组，避免重复清理
  const isColliding = (newTop) => {
    // 遍历已有的baseTop，判断是否重叠
    return Array.from(barragePositionMap.value.values()).some((existingTop) => {
      return Math.abs(newTop - existingTop) < barrageHeight + 10;
    });
  };

  let adjustCount = 0;
  while (isColliding(baseTop) && adjustCount < 2) {
    baseTop += (Math.random() > 0.5 ? 1 : -1) * 30;
    baseTop = Math.max(minTop, Math.min(baseTop, maxTop));
    adjustCount++;
  }

  // 将 baseTop 与弹幕DOM绑定，存入 Map（替代原数组）
  const barrage = document.createElement("div");
  barrage.className = "barrage-item";
  barrage.style.whiteSpace = "nowrap";
  barrage.style.overflow = "hidden";
  barrage.style.textOverflow = "ellipsis";
  barrage.style.transform = "translateZ(0)";

  // 绑定 baseTop 到当前弹幕DOM
  barragePositionMap.value.set(barrage, baseTop);
  // 原数组记录可保留
  activeBarragePositions.value.push(baseTop);

  activeBarrages.value.push({ element: barrage, item: randomItem });

  barrage.style.right = "0px";
  barrage.style.top = `${baseTop}px`;
  barrage.innerHTML = `
    <span class="barrage-text">
      恭喜 <span class="barrage-username">${
        randomItem.realname || "匿名用户"
      }</span>
      抽中了 <span class="barrage-prize">${randomItem.jp_name}</span>
    </span>
  `;

  container.appendChild(barrage);
  animateBarrage(barrage, containerWidth); // 不再传递 topPosition，从 Map 取
};

// 3. 优化 animateBarrage：从 Map 读取 baseTop，避免参数传递错误
const animateBarrage = (barrage, containerWidth) => {
  // 从 Map 中获取当前弹幕的 baseTop（精准绑定）
  const baseTop = barragePositionMap.value.get(barrage);
  if (baseTop === undefined) return; // 无位置记录，直接清理

  const totalDistance = containerWidth + 200;
  const duration = 15 + Math.random() * 5;
  const start = Date.now();

  barrage.style.opacity = 0;
  barrage.style.transform = "translateX(0)";

  const loop = () => {
    if (!isPageActive.value || !barrage.parentNode) {
      cleanupBarrage(barrage);
      return;
    }

    const elapsed = Date.now() - start;
    const progress = elapsed / (duration * 1000);

    if (progress < 1) {
      const translateX = -progress * totalDistance;
      barrage.style.transform = `translateX(${translateX}px)`;

      if (progress < 0.2) {
        barrage.style.opacity = progress / 0.2;
      } else if (progress > 0.8) {
        barrage.style.opacity = 1 - (progress - 0.8) / 0.2;
      } else {
        barrage.style.opacity = 1;
      }

      const frameId = requestAnimationFrame(loop);
      activeBarrageMap.value.set(barrage, frameId);
    } else {
      cleanupBarrage(barrage);
    }
  };

  const initialFrameId = requestAnimationFrame(loop);
  activeBarrageMap.value.set(barrage, initialFrameId);
};

// 重构 cleanupBarrage：基于 Map 精准清理 baseTop
const cleanupBarrage = (barrage) => {
  // 1. 清理动画帧
  const frameId = activeBarrageMap.value.get(barrage);
  if (frameId) {
    cancelAnimationFrame(frameId);
    activeBarrageMap.value.delete(barrage);
  }

  // 清理 baseTop（核心修复）
  const baseTop = barragePositionMap.value.get(barrage);
  if (baseTop !== undefined) {
    // 从 Map 中移除当前弹幕的位置记录
    barragePositionMap.value.delete(barrage);
    // 从原数组中移除（兼容旧逻辑，确保无残留）
    activeBarragePositions.value = activeBarragePositions.value.filter(
      (pos) => pos !== baseTop
    );
  }

  // 清理活跃弹幕记录
  activeBarrages.value = activeBarrages.value.filter(
    (item) => item.element !== barrage
  );

  // 强制移除 DOM
  if (barrage && barrage.parentNode) {
    barrage.parentNode.removeChild(barrage);
  } else if (barrage) {
    barrage = null;
  }
};

// 5. 优化 forceCleanupAllBarrages：批量清空 baseTop 记录
const forceCleanupAllBarrages = () => {
  // 遍历所有弹幕强制清理
  activeBarrages.value.forEach(({ element: barrage }) => {
    if (barrage) cleanupBarrage(barrage);
  });
  // 清空所有位置记录（关键：避免 Map 残留）
  barragePositionMap.value.clear();
  activeBarragePositions.value = [];
  // 清空动画帧映射和活跃弹幕
  activeBarrageMap.value.clear();
  activeBarrages.value = [];
};

watch(
  allLogList,
  async (newVal) => {
    if (newVal.length === 0) {
      return;
    }
    // 强制触发滚动初始化
    await initScroll();
  },
  { immediate: true } // 页面加载时立即执行
);

const initScroll = async () => {
  stopScroll(); // 先停止原有滚动

  // 等待DOM完全渲染
  await nextTick();

  // 容错：容器不存在则返回
  if (!scrollWrapRef.value) return;

  // 获取单条记录高度（增加重试机制）
  let firstItem = scrollWrapRef.value.querySelector(".info-item");
  if (!firstItem) {
    // DOM未加载时，延迟500ms重试
    setTimeout(initScroll, 500);
    return;
  }
  itemHeight.value = firstItem.offsetHeight;

  // 计算容器高度和列表总高度
  const containerHeight = scrollWrapRef.value.clientHeight;
  const singleListHeight = itemHeight.value * allLogList.value.length;

  // 数据不足一屏时不滚动
  if (singleListHeight <= containerHeight) return;

  // 启动滚动定时器（核心：确保定时器生效）
  scrollTimer.value = setInterval(() => {
    requestAnimationFrame(() => {
      scrollY.value -= scrollSpeed;
      // 重置偏移量，实现循环
      if (Math.abs(scrollY.value) >= singleListHeight) {
        scrollY.value = 0;
      }
    });
  }, scrollInterval);
};

// 停止滚动
const stopScroll = () => {
  if (scrollTimer.value) {
    clearInterval(scrollTimer.value);
    scrollTimer.value = null;
  }
  scrollY.value = 0;
};

const fetchMyLotteryLog = async () => {
  try {
    // 增加空值校验，避免接口传参异常
    if (!uid || !usertoken || !activeCode.value) {
      ElMessage.warning("参数异常，无法获取抽奖记录");
      return;
    }
    const log_res = await getlog({
      uid: uid,
      usertoken: usertoken,
      code: activeCode.value,
    });
    // 更新列表数据
    logList.value = log_res.data || [];
    // 可选：如果弹窗内也需要滚动，可在这里触发滚动初始化
    // initRecordScroll();
  } catch (e) {
    console.error("加载我的抽奖记录配置失败：", e);
    ElMessage.error("获取抽奖记录失败，请稍后重试");
    logList.value = []; // 异常时清空列表，避免旧数据残留
  }
};

async function getPrizeFromServer() {
  const res = await choujiang({
    uid: uid,
    usertoken: usertoken,
    code: activeCode.value,
  });
  return res;
}

async function startDraw() {
  stopAutoPlay();

  const res = await getPrizeFromServer();
  const prizeName = res.message;

  if (!res.status) {
    message.warning({
      message: prizeName,
      center: true,
      offset: 90,
      duration: 1500,
      customClass: "message-class",
      onClose: function () {
        if (res.message === "身份信息不完整，无法抽奖！") {
          router.push({ name: "UserInfo" });
        }
      },
    });
    return;
  }
  if (isRolling.value) return;
  isRolling.value = true;

  prizeIndex.value = res.index + 1;

  let index = 0;
  let speed = 100;
  let totalRounds = 3 * 8;
  let slowSteps = prizeIndex.value + 2 * 8;
  let steps = 0;
  let timer;

  function roll() {
    current.value = drawOrder[index % 8];
    index++;
    steps++;

    if (steps < totalRounds) {
      speed = 80;
    } else if (steps < totalRounds + 10) {
      speed += 20;
    } else {
      speed += 40;
    }

    if (steps >= totalRounds + slowSteps) {
      clearTimeout(timer);
      isRolling.value = false;

      setTimeout(() => {
        if (prizeName !== "感谢您的参与") {
          resultText.value = `${prizeName}`;
        } else {
          resultText.value = "感谢您的参与";
        }
        showResultLayer.value = true;
      }, 300);
      return;
    }

    timer = setTimeout(roll, speed);
  }

  roll();
}
</script>

<style scoped>
.cjbg {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
}
.game-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.cjtitle {
  width: 70%;
  margin: 10px auto;
}

.cj-container {
  position: relative;
}

.cjkuang {
  width: 80%;
  z-index: 1;
}

.lottery-container {
  position: relative;
  z-index: 10;
}

.lottery-grid {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 10;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  width: 80%;
  justify-content: center;
  margin: auto;
  box-sizing: border-box;
  padding: 10%;
}

.grid-item {
  aspect-ratio: 1;
  background: #ffefd8;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  border-radius: 10px;
  transition: all 0.2s ease;
  border: 2px solid #fed7a8;
  color: #ff5400;
  position: relative;
  z-index: 10;
}

.item-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.grid-item.active {
  border: 2px solid #ff423c;
  background-color: #ffe7e7;
}

.grid-item .item-img {
  width: 50%;
}

.grid-item .item-text {
  font-size: 7px;
}

.choujiang-container {
  border: 0;
  aspect-ratio: 1;
  height: 100%;
  width: 100%;
}

.choujiang {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
}

.choujiang span:nth-child(1) {
  font-size: 22px;
}

.choujiang span:nth-child(2) {
  font-size: 9px;
}

.choujiang-container button {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #ff423c;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
}

.choujiang-container button.choujiang-over {
  aspect-ratio: 1;
  color: #ff5400;
  background: #ffefd8;
  border: 2px solid #fed7a8;
  font-weight: 600;
  cursor: not-allowed;
  opacity: 0.3;
}

.activity-info {
  margin-top: 12px;
  text-align: center;
  color: #555;
  font-size: 14px;
}

.cj-info-container {
  position: relative;
  width: 80%;
  margin: auto;
  z-index: 10;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: calc(10px + env(safe-area-inset-bottom));
  box-shadow: 0 0 5px #feeabf;
  margin-bottom: 20px;
}

.info-title {
  width: 40%;
  margin: 0 auto 5px;
}

.info-title2 {
  width: 60%;
  margin: auto;
}

.info-content {
  padding: 10px 20px;
  color: #c96f00;
  background: linear-gradient(to right, #fff2d1, #ffdcad);
  border-radius: 5px;
  text-align: justify;
  word-break: normal;
  white-space: normal;
}

.guize-content-container {
  margin-bottom: 10px;
  font-size: 14px;
}

.jilu-container {
  position: relative;
  width: 100%;
  max-height: 300px;
  box-sizing: border-box;
}

.jilu-container .info-log-container {
  position: relative;
  height: 220px !important;
  overflow: hidden;
  font-size: 14px;
  text-align: left;
}

.scroll-list {
  transition: none !important; /* 关闭CSS过渡，避免和JS冲突 */
  will-change: transform;
  transform: translateZ(0); /* 硬件加速，减少卡顿 */
  width: 100%;
}

:deep(.el-text--truncated) {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-item {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 0;
  /* border-bottom: 1px solid rgba(201, 111, 0, 0.4); */
  height: 60px !important; /* 固定高度，确保每条高度一致 */
  line-height: 24px;
  overflow: hidden;
}

/* 姓名样式 */
.name-text {
  font-weight: 500;
}

/* 日期列右对齐 */
.date-col {
  text-align: right;
  color: #888;
}

.canyuren {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 14px;
  color: #2e2e2e;
}

.lottery-record-btn {
  position: relative;
  width: 100%;
  text-align: right;
  color: #fff;
  font-size: 14px;
  padding: 10px;
  z-index: 1000;
  font-weight: bold;
  letter-spacing: 1px;
}

.record-list {
  max-height: 300px; /* 限制高度，超出滚动 */
  overflow-y: auto;
}

.record-item {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  padding: 8px 0;
  border-bottom: 1px dashed rgba(201, 111, 0, 0.4);
}

.record-item:last-child {
  border-bottom: none;
}

.user {
  font-weight: 500;
  color: #333;
}

.prize {
  color: #f5222d; /* 奖品红色突出 */
  margin: 4px 0;
}

.time {
  color: #888;
  font-size: 12px;
  text-align: right;
}

.barrage-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 300px;
  overflow: hidden;
  z-index: 1000;
  pointer-events: none;
}

:deep(.barrage-item) {
  position: absolute;
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 6px 14px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transform: translateZ(0); /* 硬件加速 */
  will-change: transform, opacity; /* 告诉浏览器提前优化 */
  transition: opacity 0.5s ease;
  backface-visibility: hidden;
  perspective: 1000px;
  width: max-content;
}

.lottery-result-layer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.result-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.result-img-wrapper {
  position: relative;
}

.result-bg {
  width: 350px;
  height: auto; /* 保持图片比例 */
}

.result-text {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);
  font-size: 20px;
  color: #de2f51;
  font-weight: bold;
  text-align: center;
  padding: 0 10px;
  width: 50%;
  margin: auto;
  overflow: hidden;
}

.result-close-btn {
  display: block;
  color: #fff;
  border: none;
  font-size: 32px;
  cursor: pointer;
}

:deep(.barrage-username) {
  color: #ffd700;
  font-weight: 500;
  margin: 0 4px;
}

:deep(.barrage-prize) {
  color: #ff7a00;
  font-weight: bold;
  margin: 0 4px;
}
</style>
